import { MediaStreamConnection, MediaStreamConnector } from './MediaStreamConnector';

export interface ReconnectableConnector extends MediaStreamConnector {
    addReconnectListener(listener: (connection: MediaStreamConnection) => void): void;
    removeReconnectListener(listener: (connection: MediaStreamConnection) => void): void;
}

export function isReconnectable(connector: MediaStreamConnector): connector is ReconnectableConnector {
    return 'addReconnectListener' in connector;
}
